import { action } from 'mobx';
import { BaseEditViewStore } from 'core/stores';
import { BackOrderNewFlowEditModalForm } from 'application/pick-ticket-new-flow/forms';
import { PickTicketDetailService } from 'application/pick-ticket/services';

class BackOrderNewFlowEditModalViewStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const pickTicketDetailService = new PickTicketDetailService(rootStore.application.baasic.apiClient);

        const pickTicketDetailId = componentProps.modalParams.data.pickTicketDetailId;

        super(rootStore, {
            name: "back-order-new-flow-edit-modal",
            Form: BackOrderNewFlowEditModalForm,
            id: pickTicketDetailId,
            actions: () => {
                return {
                    get: async (id) => {
                        const response = await pickTicketDetailService.get(id);

                        return response.data;
                    },
                    updateBackOrder: async (resource) => {
                        const response = await pickTicketDetailService.updateBackOrder(resource);

                        return response;
                    }
                }
            },
            FormClass: BackOrderNewFlowEditModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.fetchTable = this.modalParams.data.fetchTable;
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.updateBackOrder) return;

        this.form.setFieldsDisabled(true);

        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.updateBackOrder({
                id: this.id,
                ...resource,
            });

            this.form.setFieldsDisabled(false);
            
            this.modalParams.close();
            this.fetchTable();
            
            this.rootStore.notificationStore.success('Pick ticket item is successfully updated.');
        } 
        catch(err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error('Error occured while trying to update pick ticket item.');
        }
    }
}

export default BackOrderNewFlowEditModalViewStore;
